import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import {
  columnCompletedOn,
  columnCreatedOn,
  columnDataOwners,
  columnDatasetLink,
  columnMultiSelect,
  columnNameLink,
  columnProject,
  columnRequester,
  columnReviewTools,
  columnStatus,
  columnTools,
  columnTransferType,
  columnWorkspaceName,
  columnWorkspaceNameLink,
} from '@/constants/fields';
import { presentationOptions } from '@/constants/states';
import CardsHeader from '@/components/cards/CardsHeader';
import paging, { onCategoryScroll } from '@/hooks/paging';
import RequestsCards from '../components/RequestsCards';
import RequestsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/RequestsPanelContainer';
import RequestsTable from '../components/RequestsTable';
import RequestsFilters from './RequestsFilters';

const COMMON_COLUMNS = [columnMultiSelect, columnNameLink, columnProject, columnDatasetLink,
  columnTransferType, columnCreatedOn, columnStatus];
const REVIEWER_COLUMNS = [columnRequester, columnWorkspaceName, columnReviewTools];
const NON_REVIEWER_COLUMNS = [columnDataOwners, columnCompletedOn, columnWorkspaceNameLink, columnTools];

const buildColumns = (review) => {
  const roleColumns = review ? REVIEWER_COLUMNS : NON_REVIEWER_COLUMNS;
  return [...COMMON_COLUMNS, ...roleColumns];
};

const RequestsPanelFull = ({
  canCreate,
  canRead,
  category,
  currentPage,
  display,
  fetchData,
  newRequestCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  requests,
  readErrors,
  readStatus,
  review,
  togglePresentation,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus);
  const columns = buildColumns(review);

  return (
    <RequestsPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-requests-panel-full">
      {display === presentationOptions.CARDS && (
      <>
        <CardsHeader
          disabled={readStatus === states.PENDING}
          onClick={() => togglePresentation(category, presentationOptions.TABLE)}
        >
          <RequestsFilters category={category} className="aridhia-list-filter" />
        </CardsHeader>
        <RequestsCards
          canCreate={canCreate && !review}
          category={category}
          handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
          items={requests}
          newRequestCode={newRequestCode}
          onCheckBoxClick={onCheckBoxClick}
          readErrors={readErrors}
          readStatus={readStatus}
          review={review}
        />
      </>
      )}
      {display !== presentationOptions.CARDS && (
      <RequestsTable
        canCreate={canCreate}
        category={category}
        columns={columns}
        currentPage={currentPage}
        fetchData={fetchData}
        newRequestCode={newRequestCode}
        onCheckBoxClick={onCheckBoxClick}
        pageCount={pageCount}
        pageSize={pageSize}
        requests={requests}
        readErrors={readErrors}
        readStatus={readStatus}
        togglePresentation={togglePresentation}
        total={total}
      />
      )}
    </RequestsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestsPanelFull);
